import 'sticky-sidebar/dist/sticky-sidebar.min.js';
const verge = require('verge');

class StickyContainer {
	constructor(container, contentWrapper, containerSelector) {
		this.container = container;
		this.contentWrapper = contentWrapper;
		this.containerSelector = containerSelector;
		this.sidebar = {};
	}

	create() {
		if (verge.viewportW() > 768) {
			this.initSidebar();
		}

		$(window).on('resize', () => {
			if (verge.viewportW() > 768) {
				this.initSidebar();
			} else {
				this.destroySidebar();
			}
		});
	}

	initSidebar() {
		if (!Object.keys(this.sidebar).length) {
			this.sidebar = new StickySidebar(this.container, {
				containerSelector: this.containerSelector,
				innerWrapperSelector: this.innerWrapperSelector,
				topSpacing: 0,
				bottomSpacing: 32
			});
		}
	}

	destroySidebar() {
		if (Object.keys(this.sidebar).length) {
			this.sidebar.destroy();
			this.sidebar = {};
		}
	}
}

// search sidebar
$(function () {
	const container = document.querySelector('.js-search');

	if ($(container).length) {
		let stickySearch = new StickyContainer(container, '.js-search__content', '.js-search');
		stickySearch.initSidebar();
	}
});



// WEBPACK FOOTER //
// ./frontend/components/sticky-sidebar/sticky-sidebar.js